<template>
  <div class="container-fluid">
    <client-form
      :loading="loading"
      :clientData="client"
      :formErrors="formErrors"
      @clientSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultClient from "../defaultClient";
import ClientForm from "../partials/ClientForm.vue";
import requestErrorMixin from "@/mixins/request-error-mixin";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ClientForm,
  },

  mixins: [alertLeave, requestErrorMixin],

  data() {
    return {
      client: cloneDeep(defaultClient),
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List Clients" });
    },

    viewClient(client) {
      this.alertLeave = false;
      this.$router.push({ name: "View Client", params: { id: client.id } });
    },

    async handleSubmit(client) {
      this.loading = true;

      const clientData = cloneDeep(client);
      delete clientData.id;

      try {
        await this.$store.dispatch("clients/add", clientData);
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("CLIENTS.CLIENT_ADDED"),
        });
        const client = await this.$store.getters["clients/client"];
        this.$emit("onViewClient", client, true);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        if (error?.response?.status === 403) {
          await this.showRequestError(error);
        } else {
          this.$notify({
            type: "danger",
            message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
          });
          this.formErrors = error.response.data.errors;
        }
      }
    },
  },
};
</script>
